jQuery(function ($) {
var header = document.querySelector(".header-wrapper");
var header_top= header.offsetHeight;

window.addEventListener('scroll', function(){
  if(window.scrollY >= 80){
    header.classList.add('active');
  }else{
    header.classList.remove('active');
  }
});


$(".header li .mega-menu")
  .on("mouseenter", function () {
    $(this)
      .find('.mega-menu__content')
      .stop(true, true)
      .fadeIn(200);
  })
  .on("mouseleave", function () {
    $(this)
      .find('.mega-menu__content')
      .stop(true, true)
      .fadeOut(200);
  });

/*
$('.list-menu--inline > li').hover(function(){
  //$(this).siblings('.mega-menu__content').('on');
  $(this).trigger('click');
});
*/

//privacy policy 스타일 변경
if (window.location.pathname === '/policies/privacy-policy') {
  $(".rte li.MsoNormal").css({
    'list-style':'unset',
    'text-indent':'-22px'
  });
}
       });